/**
 * Search tag actions.
 * @module actions/searchTag/searchTag
 */

import { compact, concat, isArray, join, map, pickBy, toPairs } from 'lodash';
import { GET_SEARCH_TAG, RESET_SEARCH_TAG } from '../../constants/ActionTypes';

/**
 * Search content function.
 * @function searchTag
 * @param {string} url Url to use as base.
 * @param {Object} options Search options.
 * @param {string} subrequest Key of the subrequest.
 * @returns {Object} Search content action.
 */
export function searchTag(url, options, subrequest = null) {
  let queryArray = [];
  // console.log({ searchContent: options });

  const arrayOptions = pickBy(options, (item) => isArray(item));

  queryArray = concat(
    queryArray,
    options
      ? join(
          map(toPairs(pickBy(options, (item) => !isArray(item))), (item) => {
            if (item[0] === 'SearchableText') {
              // Adds the wildcard to the SearchableText param
              item[1] = `${item[1]}`;
            }
            return join(item, '=');
          }),
          '&',
        )
      : '',
  );

  queryArray = concat(
    queryArray,
    arrayOptions
      ? join(
          map(pickBy(arrayOptions), (item, key) =>
            join(
              item.map((value) => `${key}:list=${value}`),
              '&',
            ),
          ),
          '&',
        )
      : '',
  );

  // queryArray.push(`lang=${Locale.getLocale()}`)

  const querystring = join(compact(queryArray), '&');

  return {
    type: GET_SEARCH_TAG,
    subrequest,
    request: {
      op: 'get',
      path: `/@search-tag${querystring ? `?${querystring}` : ''}`,
    },
  };
}

/**
 * Reset search content function.
 * @function resetSearchContent
 * @param {string} subrequest Key of the subrequest.
 * @returns {Object} Search content action.
 */
export function resetSearchTag(subrequest = null) {
  return {
    type: RESET_SEARCH_TAG,
    subrequest,
  };
}
